import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getIntegrationManagementSearchState = createSelector(getDragonflyState, (state) => state?.search);

export const getSystems = createSelector(getIntegrationManagementSearchState, (state) => state?.systems);

export const getSelectedSystem = createSelector(getIntegrationManagementSearchState, (state) => state?.system);

export const getName = createSelector(getIntegrationManagementSearchState, (state) => state?.name);

export const getActiveStatus = createSelector(getIntegrationManagementSearchState, (state) => state?.activeStatus);

export const getInActiveStatus = createSelector(getIntegrationManagementSearchState, (state) => state?.inActiveStatus);

export const getNameValue = createSelector(getIntegrationManagementSearchState, (state) => state?.nameValue);

export const getPanelExpandedValue = createSelector(
  getIntegrationManagementSearchState,
  (state) => state?.panelExpanded,
);
